/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getAlertDetails, getUserRequestAPI } from '../../API/RDPMS_API';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import HyperDatepicker from '../../components/Datepicker';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { alertDetailsColumns, mapRequestDataToOptions, sizePerPageList } from './requestDataMapper';

const AlertDetails = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    let stationIds = [sessionStorage.getItem('stationId')];

    const navigate = useNavigate();

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    // const [station, setStation] = useState([]);

    // const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const today = new Date();
        const last7Days = new Date();
        last7Days.setDate(today.getDate() - 7);
        return last7Days;
    });

    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedZones, setSelectedZones] = useState([]);
    const [selectedDivisions, setSelectedDivisions] = useState([]);
    const [selectedStation, setSelectedStation] = useState([]);
    const [selectedAssetsType, setSelectedAssetsType] = useState([]);
    const [selectedAssetsNumber, setSelectedAssetsNumber] = useState([]);
    const [selectedAlertType, setSelectedAlertType] = useState([]);
    const [selectedAlertFeedback, setSelectedAlertFeedback] = useState([]);
    const [selectedCauses, setSelectedCauses] = useState([]);

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [assetsType, setAssetsType] = useState([]);
    const [assetsNumber, setAssetsNumber] = useState([]);
    const [alertType, setAlertType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
        {
            label: 'Failure',
            value: 'FLR',
        },
        {
            label: 'Success',
            value: 'SUC',
        },
    ]);

    const [alertFeedback, setAlertFeedback] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
        {
            label: 'True',
            value: 'T',
        },
        {
            label: 'False',
            value: 'F',
        },
        {
            label: 'Maintenance',
            value: 'M',
        },
    ]);

    const [causes, setCauses] = useState([]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const [statusMessage, setStatusMessage] = useState('');
    useEffect(() => {
        getAlertDetailsData(limit, pageNumber);
        const fetchStation = async () => {
            await getRequestData(auth.user._id);
        };

        fetchStation();
    }, []);

    const { t } = useTranslation();

    const formatDateTime = (date) => {
        if (!date) return {};

        return {
            date: `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(
                2,
                '0'
            )}/${date.getFullYear()}`,
            time: `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
                date.getSeconds()
            ).padStart(2, '0')}`,
        };
    };

    const getAlertDetailsData = async (limits, pages) => {
        Loading();
        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;

        const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
        const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        const station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);

        const assetsType = selectedAssetsType.some((a) => a.value === 'all')
            ? []
            : selectedAssetsType.map((a) => a.value);

        const alertType = selectedAlertType.some((a) => a.value === 'all') ? [] : selectedAlertType.map((a) => a.value);

        const alertFeedback = selectedAlertFeedback.some((a) => a.value === 'all')
            ? []
            : selectedAlertFeedback.map((a) => a.value);

        const assetsNumber = selectedAssetsNumber.some((item) => item.value === 'all')
            ? []
            : selectedAssetsNumber.map((item) => ({
                  sc: item.sc,
                  asset_number_code: item.label,
              }));

        const causesArray = selectedCauses.some((c) => c.value === 'all') ? [] : selectedCauses.map((c) => c.value);

        let request = {
            start_date: start_date,
            start_time: start_time,

            end_date: end_date,
            end_time: end_time,
            request: {
                zone: zone,
                division: division,
                station: station,
                asset_type: assetsType,
                alert_type: alertType,
                alert_feedback: alertFeedback,
                asset_number: assetsNumber,
                cause: causesArray,
            },
            page_number: pagesNumber,
            page_size: limitNumber,
        };

        // console.log(request, 'request.........');

        let response = await getAlertDetails(request);
        // console.log(response, 'response.........');

        if (response) {
            let srNo = pagesNumber * limitNumber - limitNumber + 1;
            let dataArray = [];

            response?.zone?.forEach((z) => {
                z.division?.forEach((d) => {
                    d.station?.forEach((s) => {
                        s.alert_type?.forEach((at) => {
                            at.asset_type?.forEach((ast) => {
                                ast.asset_number?.forEach((asn) => {
                                    asn.cause?.forEach((c) => {
                                        c.alert_feedback?.forEach((af) => {
                                            af.alert_fields?.forEach((field) => {
                                                dataArray.push({
                                                    srNo: srNo++,

                                                    vcc: response.vcc || '',
                                                    vcn: response.vcn || '',

                                                    zoneCode: z.zc || '',
                                                    divisionCode: d.dc || '',
                                                    stationCode: s.sc || '',

                                                    alertType: at.alert_type_code || '',
                                                    assetType: ast.astc || '',
                                                    assetNumber: asn.asnc || '',

                                                    causeCode: c.cause_code || 'NA',
                                                    alertFeedback: af.alert_feedback_code || '',

                                                    incidenceDate: field.incidence_date_time || '',
                                                    rectificationDate: field.rectification_date_time || '',
                                                    incidenceDuration: field.incidence_duration || 0,

                                                    maintainerName: field.maintainer_name || '',
                                                    maintainerDesignation: field.maintainer_designation || '',
                                                    maintainerMobile: field.maintainer_mobile || '',
                                                    remarks: field.remarks || '',
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });

            setPageNumber(response.currentPage);
            setPageCount(response.totalPages);
            setData(dataArray);
            setTotalCount(response.totalCount);

            setStatusMessage('Alerts details fetched successfully');
        }
        Loading();
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);

            if (response) {
                const { stations, zones, divisions, assetsType, assetsNumber, causes } =
                    mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
                setAssetsType(assetsType);
                setAssetsNumber(assetsNumber);
                setCauses(causes);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAlertDetailsData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAlertDetailsData(limit, value);
    };

    return (
        <>
            <ToastContainer />

            <div className=" py-3 " style={{ width: '100%' }}>
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        {/* Alerts Overview Button */}
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Alert Details
                            </button>
                        </div>

                        {/* Dropdown and Update Button */}
                        <div className="col-12 col-md-auto ms-md-auto">
                            <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-5">
                                {/* Update Button */}
                                <button
                                    className="update d-flex align-items-center justify-content-center flex-grow-1"
                                    id="update">
                                    Update <i className="mdi mdi-autorenew ms-1"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-4 p-3"
                    style={{
                        width: '100%',
                        boxShadow: ' 0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    <div className="container form-container justify-content-center">
                        <form>
                            <div className="row d-flex flex-center">
                                {/* Start Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="startDate">Start Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>
                                    {selectedStartDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedStartDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                {/* End Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="endDate">End Date</label>
                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            defaultValue="2024-08-22"
                                            id="endDate"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => {
                                                setSelectedEndDate(date);
                                            }}
                                        />
                                    </div>
                                    {selectedEndDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedEndDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Assets Type"
                                    id="assetsSelect"
                                    options={assetsType}
                                    selectedValues={selectedAssetsType}
                                    onChange={setSelectedAssetsType}
                                />

                                <MultiSelectDropdown
                                    label="Alert Type"
                                    id="alertSelect"
                                    options={alertType}
                                    selectedValues={selectedAlertType}
                                    onChange={setSelectedAlertType}
                                />

                                <MultiSelectDropdown
                                    label="Assets Number"
                                    id="assetsNumberSelect"
                                    options={assetsNumber}
                                    selectedValues={selectedAssetsNumber}
                                    onChange={setSelectedAssetsNumber}
                                />

                                <MultiSelectDropdown
                                    label="Alert Feedback"
                                    id="alertFeedbackSelect"
                                    options={alertFeedback}
                                    selectedValues={selectedAlertFeedback}
                                    onChange={setSelectedAlertFeedback}
                                />

                                <MultiSelectDropdown
                                    label="Cause"
                                    id="causeSelect"
                                    options={causes}
                                    selectedValues={selectedCauses}
                                    onChange={setSelectedCauses}
                                />
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn "
                                        onClick={() => getAlertDetailsData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div
                    className="col-sm-12 card-alerts my-4 p-3 border-0  text-start no-radius"
                    style={{ width: '100%', position: 'relative' }}>
                    <Table
                        columns={alertDetailsColumns}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AlertDetails;
